import gql from "graphql-tag";
import { withQuery } from "containers/withQuery";

export const withERP = withQuery({
  noLoader: true,
  query: gql`{ isErpAvailable }`,
});
